import styled from 'styled-components';

export const SectionWrapper = styled.section`
  scroll-margin-top: 40px;
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
`;

export const SectionIconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 10px;
  background: #edf0ff;
  color: #6241ea;
  flex-shrink: 0;
`;

export const SectionTitle = styled.h2`
  font-size: 23px;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: #101828;
  margin: 0;
`;

interface SectionDescriptionProps {
  $withIcon: boolean;
}

export const SectionDescription = styled.p<SectionDescriptionProps>`
  font-size: 15px;
  line-height: 1.6;
  color: #667085;
  margin: 0 0 32px;
  padding-left: ${({ $withIcon }) => ($withIcon ? '44px' : '0')};
`;
